export const SMALL_SCREEN = 600;
